import { useOutletContext } from "react-router";

import { Divider, Stack, Typography } from "@mui/material";
import { ClientContent } from "@shared";

import { ClientDetailResponse } from "@/api";
import { useTranslation } from "@/translations";

import { DebtRow } from "./components/DebtRow";
import { useMeasuresCauses } from "./hooks/useMeasuresCauses";

export function MeasuresCausesView() {
  const client = useOutletContext<ClientDetailResponse>();
  const { t } = useTranslation();
  const {
    formik,
    measureOptions,
    causeOptions,
    handleAddMeasure,
    handleDeleteMeasure,
    handleAddCause,
    handleDeleteCause,
  } = useMeasuresCauses(client.clientId);

  return (
    <ClientContent formik={formik}>
      <Stack flex={1} sx={{ maxHeight: "100%", overflowY: "auto", bgcolor: "background.paper" }}>
        <Typography sx={{ p: 2, pb: 1 }} variant="h5">
          {t("clients.measuresCauses.title")}
        </Typography>

        <Stack sx={{ gap: 2, p: 2 }}>
          {formik.values.measures.map((row, index) => (
            <DebtRow
              key={row.id ?? `measure-${index}`}
              formik={formik}
              field="measures"
              index={index}
              options={measureOptions}
              label={t("clients.measuresCauses.measuresLabel")}
              isFirst={index === 0}
              addDisabled={!formik.values.measures[0]?.value}
              onAdd={handleAddMeasure}
              onDelete={() => handleDeleteMeasure(index)}
            />
          ))}

          <Divider />
          <Stack sx={{ gap: 2, pt: 2 }}>
            {formik.values.causes.map((row, index) => (
              <DebtRow
                key={row.id ?? `cause-${index}`}
                formik={formik}
                field="causes"
                index={index}
                options={causeOptions}
                label={t("clients.measuresCauses.causesLabel")}
                isFirst={index === 0}
                addDisabled={!formik.values.causes[0]?.value}
                onAdd={handleAddCause}
                onDelete={() => handleDeleteCause(index)}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </ClientContent>
  );
}
